import { render, staticRenderFns } from "./Carousel3Wrapper.vue?vue&type=template&id=fa3e6e50&"
import script from "./Carousel3Wrapper.vue?vue&type=script&lang=js&"
export * from "./Carousel3Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports